<template>
  <div id="verifier-wrapper">
    <div id="verifier-inner-wrapper" class="d-flex flex-row justify-content-center pt-3 no-print dingo">
      <div id="inner-wrapper-content" class="col-sm-12 col-md-10 col-lg-3">
        <div class="intro-text">
          This is {{ certificateProvider }}'s certificate verification facility for
          issued certificates that reside in the Ethereum Blockchain. Graduates or
          other interested third-parties may use this facility to check the
          authenticity of an issued certificate. Printing and saving the certificate
          will be available after verification.
          <div class="text-center font-weight-bold mt-3 intro-head">
            Verify for a preview of your certificate.
          </div>
        </div>

        <div v-show="showVerification">
          <verification
            :data="data"
            @finished="verificationFinished"
            ref="Verification"
          />
        </div>

        <!-- show certificate button-->
        <div v-if="isVerified" class="mt-3 pb-3 d-flex justify-content-center align-items-center">
          <button
            @click="showCertificate"
            id="verifyId"
            class="btn btn-secondary verify"
            style="background-color: #134260;"
          >
            <span>Show Certificate</span>
          </button>
        </div>

        <!-- verify button -->
        <div v-else class="mt-3 pb-3 d-flex justify-content-center align-items-center">
          <button
            @click="verifyCertificate"
            :disabled="isVerifying"
            id="verifyId"
            class="btn btn-secondary verify"
            style="background-color: #134260;"
          >
            <span v-if="isVerifying" class="loader-ellipsis mr-2">
              <span></span>
              <span></span>
              <span></span>
              <span></span>
            </span>
            <span>Verify{{ isVerifying ? "ing" : "" }} Certificate</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Verification from "./verification";

export default {
  props: ["data"],
  name: "verifier",
  components: {
    Verification
  },
  data() {
    return {
      isVerifying: false,
      isVerified: false,
      showVerification: false,
    };
  },
  computed: {
  certificateProvider() {
    return (this.data && this.data.payload && this.data.payload["@template"] && 
            this.data.payload["@template"].customCertificateProvider) || 
            "Kingsland University";
  }
},
  methods: {
    verifyCertificate: async function() {
      this.showVerification = true;
      this.isVerifying = true;
      this.isVerified = false;
      this.$refs.Verification.startVerification();
    },
    verificationFinished: function(valid) {
      this.isVerifying = false;
      this.isVerified = valid;
    },
    showCertificate: function() {
      this.$emit("finished", true);  
    },
    logData() {
      //eslint-disable-next-line no-console
      console.log("Certificate Data:", this.data);
    }
  }
};
</script>

<style scoped>
#verifier-wrapper {
  z-index: 20;
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  display: flex;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.8);
}

#verifier-inner-wrapper {
  overflow-y: auto;
  width: 100vw;
}

#inner-wrapper-content {
  margin: auto;
}

.dingo {
  -webkit-animation: fadein 2s;
  -moz-animation: fadein 2s;
  -ms-animation: fadein 2s;
  -o-animation: fadein 2s;
  animation: fadein 2s;
}

@keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Firefox < 16 */
@-moz-keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Safari, Chrome and Opera > 12.1 */
@-webkit-keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Internet Explorer */
@-ms-keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.intro-text {
  color: white;
  text-align: center;
}

.intro-head {
  font-size: 1.3rem;
}
</style>
